function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as f from "react";
import { useTheme as I, useWindowHeight as oe, useScreenSize as B, useIsomorphicLayoutEffect as $ } from "./hooks.js";
import { useIsInverseVariant as q, ThemeVariant as re } from "./theme-variant-context.js";
import te from "./button-fixed-footer-layout.js";
import E from "./overscroll-color-context.js";
import { O2_CLASSIC_SKIN as O, VIVO_SKIN as L } from "./skins/constants.js";
import _ from "./icons/icon-success.js";
import z from "./icons/icon-success-vivo.js";
import ne from "./icons/icon-error.js";
import ce from "./icons/icon-info.js";
import { isWebViewBridgeAvailable as se, requestVibration as ae } from "@tef-novum/webview-bridge";
import { isOldChrome as ie, isRunningAcceptanceTest as de } from "./utils/platform.js";
import { Text2 as me, Text6 as le, Text3 as ue } from "./text.js";
import A from "./box.js";
import { Boxed as pe } from "./boxed.js";
import v from "./responsive-layout.js";
import b from "./stack.js";
import be from "classnames";
import fe from "./button-group.js";
import { vars as s } from "./skins/skin-contract.css-mistica.js";
import { innerContainer as R, feedbackData as he, feedbackDataAppear as ke, feedbackDataAppearActive as ge, desktopContainer as Se, desktopContent as Fe, container as ve } from "./feedback.css-mistica.js";
import { jsxs as i, Fragment as Ie, jsx as e } from "./_virtual/jsx-runtime.js";
const W = (r)=>!ie(r) && !de(r), j = (param)=>{
    let { primaryButton: r , secondaryButton: o  } = param;
    return !!r || !!o;
}, Be = ()=>{
    const o = `body {background:${q() ? s.colors.backgroundBrand : s.colors.background}}`;
    return /* @__PURE__ */ e("style", {
        children: o
    });
}, D = (r)=>{
    se() && ae(r).catch(()=>{});
}, K = (r)=>{
    f.useEffect(()=>{
        let o;
        return r === "success" && (o = setTimeout(()=>D("success"), 700)), r === "error" && (o = setTimeout(()=>D("error"), 1e3)), ()=>{
            clearTimeout(o);
        };
    }, [
        r
    ]);
}, G = ()=>{
    const [r, o] = f.useState(!1);
    return $(()=>{
        const t = window.requestAnimationFrame(()=>{
            o(!0);
        });
        return ()=>window.cancelAnimationFrame(t);
    }, []), r;
}, M = (param, c, a)=>{
    let { icon: r , title: o , description: t , children: n  } = param;
    const d = t && Array.isArray(t) ? /* @__PURE__ */ e(b, {
        space: 16,
        children: t.map((u, m)=>/* @__PURE__ */ e("p", {
                children: u
            }, m))
    }) : t;
    return /* @__PURE__ */ i(b, {
        space: 24,
        children: [
            r,
            /* @__PURE__ */ i(b, {
                space: 16,
                className: be(he, c && ke, c && a && ge),
                children: [
                    /* @__PURE__ */ e(le, {
                        as: "h1",
                        children: o
                    }),
                    d && /* @__PURE__ */ e(ue, {
                        regular: !0,
                        color: s.colors.textSecondary,
                        children: d
                    }),
                    n
                ]
            })
        ]
    });
}, P = (r, o)=>{
    const t = j(o);
    return /* @__PURE__ */ i(b, {
        space: 24,
        children: [
            r,
            t && /* @__PURE__ */ e(fe, _objectSpread({}, o))
        ]
    });
}, U = (param)=>/* @__PURE__ */ {
    let { isInverse: r , inlineFeedbackBody: o , imageFit: t , imageUrl: n , dataAttributes: c  } = param;
    return i(pe, {
        className: Se,
        isInverse: r,
        dataAttributes: c,
        children: [
            /* @__PURE__ */ e("div", {
                className: Fe,
                children: /* @__PURE__ */ e(A, {
                    padding: 64,
                    children: o
                })
            }),
            n && /* @__PURE__ */ e("div", {
                style: {
                    backgroundImage: `url(${n})`,
                    backgroundPosition: t === "fit" ? "bottom right" : "center right",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: t === "fit" ? "contain" : "cover",
                    flex: 1,
                    maxWidth: 600
                }
            })
        ]
    });
}, x = (param)=>{
    let { title: r , description: o , children: t , primaryButton: n , secondaryButton: c , link: a , hapticFeedback: d , icon: u , animateText: m = !1 , unstable_inlineInDesktop: h , imageUrl: k , imageFit: g , dataAttributes: S  } = param;
    K(d);
    const l = q(), { platformOverrides: F , isDarkMode: p , skinName: T  } = I(), J = oe(), { isTabletOrSmaller: y  } = B(), [Q, X] = f.useState(typeof self < "u"), [C, Y] = f.useState(0), N = Q ? "100vh" : `${J - C}px`, V = j({
        primaryButton: n,
        secondaryButton: c,
        link: a
    }), Z = G();
    $(()=>{
        X(!1);
    }, []);
    const w = M({
        icon: u,
        title: r,
        description: o,
        children: t
    }, m && W(F), Z), H = P(w, {
        primaryButton: n,
        secondaryButton: c,
        link: a
    });
    if (!y && h) return H;
    const ee = /* @__PURE__ */ e("div", {
        className: ve,
        children: /* @__PURE__ */ e(v, {
            children: /* @__PURE__ */ e("div", {
                className: R,
                children: w
            })
        })
    });
    return y ? /* @__PURE__ */ i(Ie, {
        children: [
            l && /* @__PURE__ */ e(E, {}),
            /* @__PURE__ */ e("div", {
                style: {
                    position: "relative"
                },
                children: /* @__PURE__ */ e(te, {
                    isFooterVisible: V,
                    button: n,
                    secondaryButton: c,
                    link: a,
                    footerBgColor: l && !p ? s.colors.backgroundFeedbackBottom : void 0,
                    containerBgColor: l && !p ? s.colors.backgroundFeedbackBottom : void 0,
                    onChangeFooterHeight: Y,
                    children: ee
                })
            }),
            T === O && /* @__PURE__ */ e("div", {
                style: {
                    position: "absolute",
                    bottom: C,
                    top: 0,
                    left: 0,
                    right: 0,
                    height: V ? `calc(${N} + 1px)` : `calc(${N})`,
                    background: l ? s.colors.backgroundBrand : s.colors.background
                }
            }),
            T !== O && /* @__PURE__ */ e(Be, {})
        ]
    }) : /* @__PURE__ */ e(v, {
        children: /* @__PURE__ */ e(A, {
            paddingTop: 64,
            children: U({
                isInverse: l,
                inlineFeedbackBody: H,
                imageFit: g,
                imageUrl: k,
                dataAttributes: S
            })
        })
    });
}, Ge = (_param)=>{
    var { dataAttributes: r  } = _param, o = _objectWithoutProperties(_param, [
        "dataAttributes"
    ]);
    const { isTabletOrSmaller: t  } = B(), { skinName: n  } = I();
    return /* @__PURE__ */ e(re, {
        isInverse: !o.unstable_inlineInDesktop || t,
        children: /* @__PURE__ */ e(x, _objectSpreadProps(_objectSpread({}, o), {
            hapticFeedback: "success",
            icon: n === L ? /* @__PURE__ */ e(z, {}) : /* @__PURE__ */ e(_, {}),
            animateText: !0,
            imageUrl: o.imageUrl,
            imageFit: o.imageFit,
            dataAttributes: _objectSpread({
                "component-name": "SuccessFeedbackScreen"
            }, r)
        }))
    });
}, Me = (_param)=>/* @__PURE__ */ {
    var { children: r , errorReference: o , dataAttributes: t  } = _param, n = _objectWithoutProperties(_param, [
        "children",
        "errorReference",
        "dataAttributes"
    ]);
    return i(x, _objectSpreadProps(_objectSpread({}, n), {
        hapticFeedback: "error",
        icon: /* @__PURE__ */ e(ne, {}),
        animateText: !0,
        dataAttributes: _objectSpread({
            "component-name": "ErrorFeedbackScreen"
        }, t),
        children: [
            r,
            o && /* @__PURE__ */ e(me, {
                color: s.colors.textSecondary,
                regular: !0,
                children: o
            })
        ]
    }));
}, Pe = (_param)=>/* @__PURE__ */ {
    var { dataAttributes: r  } = _param, o = _objectWithoutProperties(_param, [
        "dataAttributes"
    ]);
    return e(x, _objectSpread({
        dataAttributes: _objectSpread({
            "component-name": "InfoFeedbackScreen"
        }, r),
        icon: /* @__PURE__ */ e(ce, {})
    }, o));
}, Ue = (param)=>{
    let { title: r , description: o , children: t , primaryButton: n , secondaryButton: c , link: a , imageUrl: d , imageFit: u , dataAttributes: m  } = param;
    K("success");
    const { isTabletOrSmaller: h  } = B(), { skinName: k , platformOverrides: g  } = I(), S = G(), F = M({
        icon: k === L ? /* @__PURE__ */ e(z, {}) : /* @__PURE__ */ e(_, {}),
        title: r,
        description: o,
        children: t
    }, W(g), S), p = P(F, {
        primaryButton: n,
        secondaryButton: c,
        link: a
    });
    return h ? /* @__PURE__ */ i(v, {
        isInverse: !0,
        children: [
            /* @__PURE__ */ e(E, {}),
            /* @__PURE__ */ e(A, {
                paddingBottom: 32,
                dataAttributes: _objectSpread({
                    "component-name": "SuccessFeedback"
                }, m),
                children: /* @__PURE__ */ e("div", {
                    className: R,
                    children: p
                })
            })
        ]
    }) : U({
        isInverse: !0,
        inlineFeedbackBody: p,
        imageFit: u,
        imageUrl: d,
        dataAttributes: _objectSpread({
            "component-name": "SuccessFeedback"
        }, m)
    });
};
export { Me as ErrorFeedbackScreen, x as FeedbackScreen, Pe as InfoFeedbackScreen, Ue as SuccessFeedback, Ge as SuccessFeedbackScreen };
